<template>
  <div class="log-deleted-events text-dark">
    <h2 class="marg-5-bottom">{{ $t('vue2.deleted_subjects_log.deleted_log') }} "{{ subject.name }}"</h2>
    <Loader bg-color="#f6f9fc" v-if="isLoading"></Loader>
    <div v-else>
      <p class="text-explainer" v-if="sortedLog.length < 1">{{ $t('vue2.deleted_subjects_log.no_lessons_deleted') }}</p>
      <ul class="log-deleted-events__list" v-if="sortedLog.length > 0">
        <li class="log-deleted-events__event log-deleted-events__event__header">
          <div><b>{{ $t('vue2.deleted_subjects_log.lesson') }}</b></div>
          <div><b>{{ $t('vue2.deleted_subjects_log.deleted') }}</b></div>
        </li>
        <li v-for="logEvent in sortedLog"
            :key="logEvent.id"
            class="log-deleted-events__event">
          <div class="log-deleted-events__event__event-datetime subject-event" :style="{'backgroundColor': subject.color}">
            {{ logEvent.v_eventDate }}
          </div>
          <div :content="logEvent.v_formattedDate"
               v-tippy="{
            arrow: true,
            placement : 'top'
                  }" class="text-greyed">
            <span class="icon-bin text-greyed"></span>
            {{ logEvent.name }} -
            {{ logEvent.v_humanizedDate }} {{ $t('vue2.common.ago') }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Loader from '../common/Loader'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import moment from 'moment'

export default {
  components: {Loader},
  props: {
    subject: {
      required: true,
      type: Object,
      default: null
    }
  },
  data () {
    return {
      log: [],
      isLoading: false
    }
  },
  computed: {
    sortedLog () {
      return this.log
        // create a copy before sorting
        .slice()
        .sort((a, b) => moment(b.ts).valueOf() - moment(a.ts).valueOf())
        .map(item => {
          return {
            ...item,
            v_formattedDate: this.formatDate(item.ts),
            v_humanizedDate: this.getDuration(item.ts),
            v_eventDate: this.getEventDate(item)
          }
        })
    }
  },
  methods: {
    getEventDate (item) {
      const start = item.start_time ? moment(item.start_time).format('llll') : ''
      const end = item.end_time ? moment(item.end_time).format('LT') : ''
      return start + ' - ' + end
    },
    formatDate (datetime) {
      return datetime ? moment(datetime).format('LLL') : datetime
    },
    getDuration (datetime) {
      let diff = moment().diff(moment(datetime))
      return moment.duration(diff).humanize()
    },
    readDeletedEventsLog () {
      this.isLoading = true
      const schoolId = this.subject.school_id
      const subjectId = this.subject.id
      docendo.auditDeletedEventsBySubject(schoolId, subjectId, success => {
        if (success.status === 'error') {
          eventbus.toast = {text: success.message, success: false}
          this.isLoading = false
          return
        }
        this.log = success
        this.isLoading = false
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.sms.an_error_occured'), success: false}
        this.isLoading = false
      })
    }
  },
  mounted () {
    this.readDeletedEventsLog()
    if (window.Intercom) {
      window.Intercom('trackEvent', 'Docendo Feature: Log Of Deleted Events')
    }
  }
}
</script>

<style scoped>
.log-deleted-events__event {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0.5rem;
  border-bottom: 1px solid #ccc;
}

.log-deleted-events__event:hover {
  background: #eee;
}

.text-greyed {
  color: #a2a3a6
}

.log-deleted-events__list {
  border: 1px solid #ccc;
  border-width: 1px 1px 0 1px;
  border-radius: 4px;
}

.log-deleted-events__list li:last-child {
  border-radius: 0 0 4px 4px;
}

.log-deleted-events__event__header {
  background: #fff !important;
  border-radius: 4px 4px 0 0;
}

.subject-event {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// SubjectFormLogDeletedEvents.vue?8f092bd6